import React, { useEffect, useState } from 'react'; 
import mData from '../hybriddata/mainform.json';
import { FormDropDownList, HFormInput } from '../validation/Form-Components';
import { Field } from '@progress/kendo-react-form';
import CusAddBtn from '../components/CusAddBtn';
import helper from '../factory/Helper';
import { spaceValidator } from '../validation/Validators';

const PromoCodeSelection = (props) => {
 
    const {disabled, fProps, showProRefDiv2} = props;
    const [showPromoReferalDiv2, setShowPromoReferalDiv2] = useState(showProRefDiv2);
    const [selectedDDLPromoReferal1,setSelectedDDLPromoReferal1] = useState(fProps.valueGetter('ddlPromoReferal1'));
 
    useEffect(() => {

        console.log('@PromoCodeSelection useEffect');
        
        return () => {
            console.log('clean up')
        }
    }, []);

    const onAddBtnClick = (e)=> {
        if(!disabled) {
            if(selectedDDLPromoReferal1.value === mData.promoReferalDDList[0].value) { //promo
                fProps.onChange('ddlPromoReferal2', { value: mData.promoReferalDDList[1]});
            }
            else {//referral
                fProps.onChange('ddlPromoReferal2', { value: mData.promoReferalDDList[0]});
            }
            setShowPromoReferalDiv2(true);
        }
    }
    
    const onRemoveBtnClick = (e)=> {
        
        if(disabled){
            //do nth
            return;
        }
    }

    const onRemoveBtnClick2 = () => {
        fProps.onChange('ddlPromoReferal2', { value: null});
        fProps.onChange('promoReferalValue2', { value: ''});
        setShowPromoReferalDiv2(false);
    }

    const disablePromoReferal1 = () => {
        if(disabled) {
            return true;
        }
        else if(showPromoReferalDiv2){
            return true;
        }
        else {
            return false;
        }
    }

    return(
        <div>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <Field  
                        id={'ddlPromoReferal1'} name={'ddlPromoReferal1'}
                        component={FormDropDownList}
                        textField={'label'}
                        dataItemKey={'value'}
                        data={mData.promoReferalDDList}
                        disabled={disablePromoReferal1()}
                        onChange={(e) => {
                            const result = e.value;
                            setSelectedDDLPromoReferal1(result);
                        }}
                    />
                </div>
                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <div>
                        <div style={{width:'92%',float:'left'}}>
                            <Field id={'promoReferalValue1'} 
                                name={'promoReferalValue1'}
                                placeholder={'Optional (e.g. HERpwr11)'}
                                component={HFormInput} 
                                disabled={disabled}
                                maxLength={20}
                                validator={spaceValidator}
                                />
                        </div>
                        <div style={{width:'8%',float:'left',textAlign:'right'}}>
                            <span className="k-icon k-i-delete" style={{fontSize:'22px', color:'#8D8D8D',marginTop:'1.5rem'}} 
                                onClick={onRemoveBtnClick}></span>
                        </div>
                    </div>
                </div>
            </div>
            {!showPromoReferalDiv2 &&
            <CusAddBtn id={'AddBtn1'} label={'Add promo/referral code (optional)'} onClick={onAddBtnClick} disabled={false} />
            }
            {showPromoReferalDiv2 &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                    <Field  
                        id={'ddlPromoReferal2'} name={'ddlPromoReferal2'}
                        component={FormDropDownList}
                        textField={'label'}
                        dataItemKey={'value'}
                        disabled={disabled}
                        data={helper.filterArrayByValue(helper.filterArrayByValue(mData.promoReferalDDList),selectedDDLPromoReferal1.value)}
                    />
                </div>
                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                    <div>
                        <div style={{width:'92%',float:'left'}}>
                            <Field id={'promoReferalValue2'} 
                                name={'promoReferalValue2'}
                                placeholder={'Optional (e.g. HERpwr11)'}
                                component={HFormInput} 
                                disabled={disabled}
                                maxLength={20}
                                validator={spaceValidator}
                                />
                        </div>
                        <div style={{width:'8%',float:'left',textAlign:'right'}}>
                            <span className="k-icon k-i-delete" style={{fontSize:'22px', color:'#8D8D8D',marginTop:'1.5rem'}} 
                                onClick={onRemoveBtnClick2}></span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default PromoCodeSelection